


































































import BaseFormEdit from '../../models/base.form.edit';
import { Component } from 'vue-property-decorator';

@Component({})
export default class Edit extends BaseFormEdit {
  form = { hlaType: 1,  sourceG1: '', sourceG2: '', destG1: '', destG2: ''} as any;
  get title() {
    return this.form.isNew ? this.$t('Добавление в справочник аллелей') + '' : this.$t('Аллель') + ` ${this.form.sourceG1}:${this.form.sourceG2}`;
  }
}
